import * as React from 'react';
import { SVGProps } from 'react';

const SvgCovid19Thermometer = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
    <path
      fill={props.fill}
      d="m30.15 12.849-5.202.096-10.404 10.491c-.382-.096-.764-.192-1.193-.192-2.196 0-3.961 1.773-3.961 3.976s1.766 3.976 3.961 3.976a3.96 3.96 0 0 0 3.961-3.976c0-.431-.095-.862-.191-1.246L30.15 12.848z"
    />
    <path
      fill="currentColor"
      d="M33.204 7.244c-1.766-1.773-4.725-1.629-6.634.287l-12.313 12.36c-.286-.048-.621-.048-.907-.048-4.057 0-7.35 3.306-7.35 7.378s3.293 7.377 7.35 7.377c4.057 0 7.35-3.306 7.35-7.377 0-.24 0-.479-.048-.671l12.552-12.647a4.67 4.67 0 0 0 0-6.659zm-1.336 5.318-3.389 3.401-2.1-2.108-1.384 1.389 2.1 2.108-1.098 1.102-2.1-2.108-1.384 1.389 2.1 2.108-1.098 1.102-2.1-2.108-1.384 1.389 2.1 2.108-1.098 1.102-2.148-2.108-1.384 1.389 2.1 2.108-1.002 1.006.095.431c.048.287.096.623.096.91 0 3.018-2.434 5.461-5.441 5.461S7.908 30.19 7.908 27.22c0-2.826 2.148-5.174 4.916-5.413 0 0 .907-.048 1.67.048l.429.096L27.952 8.873c1.002-1.006 2.816-1.437 3.914-.287a2.811 2.811 0 0 1 0 3.976z"
    />
  </svg>
);

export default SvgCovid19Thermometer;
